import React, { useEffect, useLayoutEffect, useState } from "react";
import airconunitService from "../services/airconunit.service";
import ReactPaginate from "react-paginate";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import { format } from "date-fns";
import Loader from "../components/Loader";
import { Link, useNavigate } from "react-router-dom";
import Alertmsg from "../components/Alertmsg";
const Airconunit = () => {
  let navigate = useNavigate();
  const [isLoaded, setIsLoaded] = useState(false);
  const [ismessage, setIsmessage] = useState(false);

  const [airconunits, setAirconunits] = useState([]);
  const [result, setResult] = useState([]);
  //smart table data
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState("");
  const [search, setSearch] = useState("");
  const [between, setBetween] = useState("");
  const [sort, setSort] = useState("");
  const [group, setGroup] = useState("");

  const [pagecount, setPagecount] = useState("");
  const [resultCount, setResultcount] = useState("");

  //table header arrays
  const tableHeaders = [
    { label: "airconunit ID", value: "" },
    { label: "airconunit name", value: "au_name" },
    { label: "Status", value: "au_status" },
    { label: "Created", value: "createdAt" },
    { label: "actions", value: "" },
  ];
  //filter arrays
  const statusfilterarr = [
    { status_id: "01", status_name: "pending" },
    { status_id: "02", status_name: "active" },
    { status_id: "03", status_name: "inactive" },
  ];
  const [filterarray, setFilterarray] = useState(statusfilterarr);
  //date range
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const selectionRange = {
    startDate: startDate,
    endDate: endDate,
    key: "selection",
  };

  //use effects
  useEffect(() => {
    getallAirconunit();
  }, []);
  useLayoutEffect(() => {
    getallAirconunit();
  }, [page, limit, filter, search, between, sort]);

  //get allairconunit
  const getallAirconunit = async () => {
    setIsLoaded(true);
    var data = {
      limit: limit,
      page: page,
      filter: filter,
      search: search,
      between: between,
      sort: sort,
      group: group,
    };
    return await airconunitService
      .getallAirconunit(data)
      .then((res) => {
        if (res.data.result) {
          setIsLoaded(false);
          setAirconunits(res.data.result.data);
          setResult(res.data);
          setPage(res.data.result.page);
          setLimit(res.data.result.limit);
          setPagecount(res.data.result.pagecount);
          setResultcount(res.data.result.resultcount);
          console.log(res.data);
        } else {
          setIsmessage(res.data.message);
          setIsLoaded(false);
        }
      })
      .catch((err) => {
        setIsLoaded(false);
        setIsmessage(err.message);
      });
  };
  //pagination
  const paginationfn = (event) => {
    setPage(event.selected + 1);
    console.log(event.selected + 1);
  };
  //search
  const searchfn = (e) => {
    setPage(1);
    setSearch(e.target.value);
  };
  //filter
  const [filterArr, setfilterArr] = useState([]);
  const filterfn = (value) => {
    setPage(1);
    var index = filterArr.indexOf(value);
    if (index > -1) {
      filterArr.splice(index, 1);
      setFilter(filterArr.toString());
    } else {
      filterArr.push(value);
      setFilter(filterArr.toString());
    }
  };
  //sort
  const sortfn = (value) => {
    /*    setSort(value); */
    if (sort === value + " desc") {
      setSort(value + " asc");
      console.log(value + " asc");
    } else if (sort === value + " asc") {
      setSort("");
      console.log(value + "");
    } else {
      setSort(value + " desc");
      console.log(value + " desc");
    }
  };
  //between
  /* const [betweenstart, setBetweenstart] = useState("");
  const [betweenend, setBetweenend] = useState("");
  const betweenfn = (value, e) => {
    setPage(1);
    if (e === null || e === "") {
      setBetween("");
      setBetweenstart("");
      setBetweenend("");
    } else {
      if (value === "start") {
        setBetween(e + "," + e);
        console.log(e + "," + e);
        setBetweenstart(e);
        setBetweenend(e);
      } else if (value === "end") {
        setBetweenend(e);
        const dd = between.split(",");
        setBetween(dd[0] + "," + e);
        console.log(dd[0] + "," + e);
        setBetweenstart(dd[0]);
        setBetweenend(e);
      } else {
        setBetween("");
        setBetweenstart("");
        setBetweenend("");
      }
    }
  }; */
  const betweenfn = async (date) => {
    await setStartDate(date.selection.startDate);
    await setEndDate(date.selection.endDate);
    setBetween(
      format(date.selection.startDate, "yyyy-MM-dd") +
        " , " +
        format(date.selection.endDate, "yyyy-MM-dd")
    );
  };
  const resetbetweenfn = () => {
    setBetween("");
    setStartDate(new Date());
    setEndDate(new Date());
  };
  const resetfilterfn = () => {
    setFilter("");
  };
  const selectedcolor = (value) => {
    if (value === "active") {
      return "badge rounded-pill bg-success";
    } else if (value === "pending") {
      return "badge rounded-pill bg-warning ";
    } else if (value === "inactive") {
      return "badge rounded-pill bg-danger";
    } else {
      return "badge rounded-pill bg-dark";
    }
  };
  // Call airconunit clicks to request another page.
  if (ismessage == "Network Error") {
    return <Alertmsg alertmsg={ismessage} type={false} />;
  }
  /* if (isLoaded == true) {
    return <Loader />
  } */

  return (
    <div className="">
      <div className="text-center">
        {/*  loader and error handler */}
        {isLoaded ? <Loader /> : <></>}
      </div>
      {/*  container */}
      <div className="airconunit-container">
        {/* tebale header part search,filter,sort */}
        <div className="d-md-flex  mb-2 ">
          {/* create airconunit */}
          <div className="m-1">
            <button
              onClick={() => {
                navigate("/airconunitevent");
              }}
              type="submit"
              className="btn btn-primary  w-100"
            >
              <i className="fa fa-plus-circle"></i> Create
            </button>
          </div>
          {/* filter status*/}
          <div className="dropdown m-1">
            <button
              className="btn btn-primary w-100 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="fa fa-filter" aria-hidden="true"></i> Filter
            </button>
            <ul
              style={{ minWidth: 200 }}
              className="dropdown-menu p-2"
              aria-labelledby="dropdownMenuButton1"
            >
              <li className="text-secondary">Airconunit Status</li>
              {filterarray.map((filterdata, index) => (
                <li key={index}>
                  <div className="form-check">
                    <input
                      onChange={(e) => filterfn(filterdata.status_name)}
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    ></input>
                    <label
                      className="form-check-label text-dark"
                      htmlFor="flexCheckDefault"
                    >
                      {filterdata.status_name}
                    </label>
                  </div>
                </li>
              ))}
              <li></li>
            </ul>
          </div>
          {/* search */}
          <div className=" m-1">
            <input
              className="form-control"
              onChange={searchfn}
              placeholder="search"
              type="search"
            ></input>
          </div>
          {/*  date range  */}
          <div className="m-1 ms-auto">
            <div className="btn-group" role="group">
              {between ? (
                <button
                  type="button"
                  className="btn bg-white border me-1 "
                  onClick={resetbetweenfn}
                >
                  <i className="fa fa-times" aria-hidden="true"></i>
                </button>
              ) : (
                <></>
              )}
              <button
                className="btn bg-white border dropdown-toggle"
                id="dropdownMenuClickableInside"
                data-bs-toggle="dropdown"
                data-bs-auto-close="outside"
                aria-expanded="false"
              >
                <i className="fa fa-calendar" aria-hidden="true"></i> {between}
              </button>
              <ul
                className="dropdown-menu"
                aria-labelledby="dropdownMenuClickableInside"
              >
                <li className="">
                  <DateRangePicker
                    ranges={[selectionRange]}
                    onChange={(date) => betweenfn(date)}
                  />
                </li>
                <li className="text-end">
                  <a onClick={resetbetweenfn} className="btn">
                    Reset
                  </a>
                  {/*  <a data-bs-dismiss="dropdown"  className="btn">Okay</a> */}
                </li>
              </ul>
            </div>
          </div>
          {/* between */}
          {/*  <div className="m-1">
                        <input
                            id="betweenstart"
                            className="form-control"
                            value={betweenstart}
                            onChange={(e) => betweenfn("start", e.target.value ? e.target.value : '')}
                            placeholder="start"
                            type="date"
                        ></input>
                    </div>
                    <div className="m-1">
                        <input
                            id="betweenend"
                            className="form-control"
                            value={betweenend}
                            onChange={(e) => betweenfn("end", e.target.value)}
                            placeholder="start"
                            type="date"
                        ></input>
                    </div> */}
        </div>
        {/* table section*/}
        <div className="table-responsive card bg-white border-0 mb-2">
          <table className="table table-striped table-hover">
            <thead>
              <tr>
                {tableHeaders.map((data, index) => (
                  <th key={index} scope="col">
                    {data.label}
                    {/* table sort */}
                    {data.value != "" ? (
                      <a
                        onClick={() => sortfn(data.value)}
                        className="btn btn-sm"
                      >
                        <span
                          className={
                            sort === data.value + " asc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          {" "}
                          <i className="fa fa-long-arrow-up"></i>
                        </span>
                        <span
                          className={
                            sort === data.value + " desc"
                              ? "text-dark"
                              : "text-secondary"
                          }
                        >
                          <i className="fa fa-long-arrow-down"></i>
                        </span>
                      </a>
                    ) : (
                      <></>
                    )}
                  </th>
                ))}
                {/* <th scope="col">#</th>
                <th scope="col">airconunit name</th>
                <th scope="col">Status</th>
                <th style={{ width: 100 }} scope="col">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {/* table data */}
              {airconunits ? (
                <>
                  {airconunits.map((data, index) => (
                    <tr key={index}>
                      <td>{data.au_id}</td>
                      <td>{data.au_name}</td>
                      <td>
                        <span className={selectedcolor(data.au_status)}>
                          {data.au_status}
                        </span>
                      </td>
                      <td>{format(new Date(data.createdAt), "PPpp")}</td>
                      <td className="p-1 m-0">
                        <Link
                          className="btn btn-light me-2"
                          to={"/airconunitevent?au_id=" + data.au_id}
                        >
                          <i className="fa fa-eye" aria-hidden="true"></i>
                        </Link>
                      </td>
                    </tr>
                  ))}
                </>
              ) : (
                <tr>
                  <td colSpan={6} className="text-center">
                    <div className="text-center p-3">0 data found</div>
                  </td>
                </tr>
              )}
            </tbody>
            <caption className="">
              <div className="d-flex">
                <div className="flex-fill"></div>
                <div className="p-1 "> Items per page </div>
                <div>
                  {" "}
                  <select
                    value={limit}
                    onChange={(e) => {
                      setLimit(e.target.value);
                      setPage(1);
                    }}
                    className="form-select form-select-sm"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="20">20</option>
                  </select>
                </div>
                <div className="p-1 me-4">
                  {page * limit - limit}-{page * limit} of {resultCount}
                </div>
                <ReactPaginate
                  previousLabel="< Prev"
                  nextLabel="Next >"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  breakLabel="..."
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                  pageCount={pagecount}
                  marginPagesDisplayed={3}
                  pageRangeDisplayed={3}
                  onPageChange={paginationfn}
                  containerClassName="pagination"
                  activeClassName="actives"
                  disabledLinkClassName="text-secondary"
                  forcePage={page - 1}
                />
              </div>
            </caption>
          </table>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default Airconunit;
